import { render, staticRenderFns } from "./FooterPart.vue?vue&type=template&id=3cec5782&"
import script from "./FooterPart.vue?vue&type=script&lang=js&"
export * from "./FooterPart.vue?vue&type=script&lang=js&"
import style0 from "./FooterPart.vue?vue&type=style&index=0&id=3cec5782&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports